import React from 'react';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import { TranslationKey } from '../../../../../i18n/i18n';
import { widgetCoverDataHooks } from './WidgetCover.dataHooks';
import styles from './WidgetCover.scss';

interface WidgetCoverProps extends WithTranslations {
  title: TranslationKey;
  description: TranslationKey;
  dataHook?: string;
}

const WidgetCoverCmp: React.FC<WidgetCoverProps> = ({ title, description, t, dataHook }) => (
  <div className={styles.container} data-hook={dataHook}>
    <div className={styles.title} data-hook={widgetCoverDataHooks.title()}>
      {t(title)}
    </div>
    <div className={styles.description} data-hook={widgetCoverDataHooks.description()}>
      {t(description)}
    </div>
  </div>
);

export const WidgetCover = withTranslations(WidgetCoverCmp);
